export enum ROUTE_LOGOUT {
  LOGOUT = 'logout'
}